import React, { useState, useEffect, useRef } from "react";
import styles from "./CustomerServiceSection.module.css";
import { useAppDispatch, useAppSelector } from "../../../../store/common/hooks";
import {
  onChatbotActions,
  postHitlMessageApiCall,
} from "../../../../store/chatbot.slice";
import JokerAiPocket from "./pocket/JokerAiPocket";
import { MessageStatus } from "../../dataModel/ChatBotDataModel";
import { CHAT_MEMBER_ID } from "../CreateFlow";
import ArrowButton from "./ArrowButton";
import AgentChatBubble from "./bubble/AgentChatBubble";
import ScreenshotSelector from "./screenshotSelector/ScreenshotSelector";
export interface ChatMessage {
  content: string;
  id: string;
  sender: string;
  tags: string[];
  timestamp: string;
  type: string;
  image_urls: string[];
}

interface CustomerServiceSectionProps {}

const CustomerServiceSection: React.FC<CustomerServiceSectionProps> = ({}) => {
  const [inputText, setInputText] = useState("");
  const [chatData, setChatData] = useState<ChatMessage[]>([]);

  const chatContainerRef = useRef<HTMLDivElement>(null);

  const dispatch = useAppDispatch();

  const adminResponse = useAppSelector(
    (state) => state.chatbot.customerSentEvent
  );

  useEffect(() => {
    if (adminResponse.message || adminResponse.image_urls) {
      const newMessage: ChatMessage = {
        id: crypto.randomUUID(),
        content: adminResponse.message ?? "",
        sender: "BOT",
        tags: [],
        timestamp: new Date().toISOString(),
        type: "text",
        image_urls: adminResponse.image_urls ? adminResponse.image_urls : [],
      };
      setChatData((prevData) => [...prevData, newMessage]);
    }
  }, [adminResponse]);

  useEffect(() => {
    if (chatContainerRef?.current) {
      if (chatContainerRef.current) {
        chatContainerRef.current.scrollTo({
          top: chatContainerRef.current.scrollHeight,
          behavior: "smooth",
        });
      }
    }
  }, [chatContainerRef, chatData]);

  useEffect(() => {
    window.addEventListener(
      "rcb-post-inject-message",
      handleChatHistoryChanged
    );
    return () => {
      window.removeEventListener(
        "rcb-post-inject-message",
        handleChatHistoryChanged
      );
    };
  }, []);

  const handleChatHistoryChanged = (event: any) => {
    setChatData((prevData) => {
      if (prevData.length < 1 || event.data.message.sender !== "BOT") {
        return [...prevData, event.data.message];
      }
      return prevData;
    });
  };

  const hitlApiCall = async (
    message: string,
    memberId: number,
    messageStatus: MessageStatus,
    messageId?: string
  ) => {
    dispatch(
      postHitlMessageApiCall(message, memberId, messageStatus, messageId)
    );
    setInputText("");
  };

  const handleSubmit = () => {
    if (inputText != "") {
      hitlApiCall(inputText, CHAT_MEMBER_ID, MessageStatus.Manual);
    }
  };

  const handleEndConversation = () => {
    dispatch(onChatbotActions.setEndConversation(true));
    setChatData([]);
  };

  return (
    <div className={styles["container"]}>
      <div className={styles["top-bar"]}>Agent Simulator</div>
      <div className={styles["main-container"]}>
        <div className={styles["chat-main-container"]}>
          <div className={styles["chat-container"]} ref={chatContainerRef}>
            {chatData &&
              chatData.map((data, index) => {
                return <AgentChatBubble data={data} key={index} />;
              })}
          </div>
          <div className={styles["chat-input-container"]}>
            <div className={styles["chat-input-area"]}>
              <textarea
                className={styles["chat-input"]}
                placeholder="Say something..."
                value={inputText}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSubmit();
                  }
                }}
                onChange={(e) => setInputText(e.target.value)}
              />
              <ArrowButton
                className={styles["send-button"]}
                onClick={handleSubmit}
              />
            </div>
            <div className={styles["send-section"]}>
              <ScreenshotSelector />
            </div>
          </div>
        </div>

        <div className={styles["conversation-list-container"]}>
          <div className={styles["conversation-list-title"]}>
            {/* Conversations: */}
          </div>
          <div className={styles["conversation-list"]}>
            {/* <div className={styles["conversation-item"]}>
              Conversation 1
            </div> */}
            <JokerAiPocket endConversationCallback={handleEndConversation} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerServiceSection;
